
import { mapGetters } from 'vuex'

export default {
    name: 'SupplyDemandInfo',
    filters: {
        withPlusMinusAndPercent(value) {
            if (!value) return ' 0.00 %'

            if (value > 0) return `+${value} %`

            if (value < 0) return `${value} %`

            return value
        },

        withPlusMinus(value) {
            if (!value) return ' 0'

            if (value.substr(0,1) !== '-') return `+${value}`

            return value
        },

        undefinedProcessor(value) {
            if (!value) return ' 0'

            return value
        },
    },
    props: {
        priceItems: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            getData: [],
        }
    },
    computed: {
        ...mapGetters('search', ['getSupplyData']),
    },
    methods: {
        NumStyle(value) {
            if(value !== undefined && value !== '' && value !== 0 && value !== null) {
            const formatter = new Intl.NumberFormat('ko-KR', {
                currency: 'KRW',
                minimumFractionDigits: 0,
            })

            return formatter.format(value)
            }
        },
        UpDownArrow(value) {
            if(value !== undefined && value !== '' && value !== 0 && value !== null) {
                if (value > 0) return { 'plus': true } // 22.07.18 suye arrow (세모표시)클래스 삭제 

                if (value < 0) return { 'minus': true } // arrow
            }
        },
        UpDownArrowString(value) {
            if(value !== undefined && value !== '' && value !== 0 && value !== null) {
                if (value.substr(0,1) === '-') {
                    return { 'minus': true } // arrow
                }
                else{
                    return { 'plus': true } // arrow
                }
            }
           
            
        },        
    },
}
